export class ImageDimensions {
  width: number;
  height: number;
  scale: number;
}
